import React from 'react';
import ReactDOM from 'react-dom/client';

import * as analytics from 'analytics/Analytics';
import BufferTabView from 'buffers/BufferTabView';
import {REGISTRY_ANALYTICS_ACTIONS} from 'constants/analytics-products';
import {renderToDOM, unmountRootsAsync} from 'redux-stores/ReduxDOMRender';
import EntityMap from 'registry/entity-map/EntityMap';
import {
  EntityMapUnavailableReason,
  EntityMapUnavailableView,
} from 'registry/entity-map/EntityMapUnavailableView';
import EntityMapTabState from 'registry/entity-map/tab/EntityMapTabState';

export default class EntityMapTabView extends BufferTabView<EntityMapTabState> {
  reactRoot: ReactDOM.Root | null = null;

  openedEntityMapTabEvent = REGISTRY_ANALYTICS_ACTIONS.OPENED_ENTITY_MAP_TAB;

  static override initClass(): void {
    this.prototype.className = 'buffer-tab buffer-tab--no-padding';
  }

  private isEntityArchived(): boolean {
    return this.model.get('model').isArchived();
  }

  override afterAttach(): void {
    super.afterAttach();
    analytics.trackEvent(this.openedEntityMapTabEvent, {
      mainEntityId: this.model.get('model').id,
      isArchived: this.isEntityArchived(),
    });
  }

  override render(): EntityMapTabView {
    const model = this.model.get('model');

    const entityMap = this.isEntityArchived() ? (
      <EntityMapUnavailableView unavailableReason={EntityMapUnavailableReason.ARCHIVED} />
    ) : (
      <EntityMap entityId={model.id} />
    );

    this.reactRoot = renderToDOM(entityMap, this.el, this.reactRoot);

    return this;
  }

  override removeAsync(callback: () => void): this {
    unmountRootsAsync([this.reactRoot], () => {
      this.reactRoot = null;
      super.remove();
      callback();
    });
    return this;
  }
}

EntityMapTabView.initClass();
